// @react-functional

import React from 'react';
import ReactDOM from 'react-dom';
import { Banner } from './components/banner/Banner';
import { acceptCookies } from './acceptCookies';
import { startLogRocket } from '../providers/logRocket';
import { providerKeys, getCookiesPolicy } from './cookiesUtils';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import { CommonAppProviders } from '../common/components/common-app/CommonAppProviders';

function detectUserNavigationForOptIn(event: MouseEvent) {
  // user auto opt-in if he clicks on an hyperlink except for cookie edit page
  if (event.target instanceof HTMLAnchorElement) {
    let element = event.target;
    while (
      element &&
      element.nodeName &&
      element.nodeName.toLowerCase() !== 'a'
    ) {
      element = element.parentElement as HTMLAnchorElement;
    }
    const isNotEditCookieLink =
      element && element.href && element.href.indexOf('/cookies') === -1;
    if (element && isNotEditCookieLink) {
      acceptCookies();
      window.removeEventListener('click', detectUserNavigationForOptIn);
    }
  }
}

function displayCookieBannerWhenNeeded() {
  const cookie = getCookiesPolicy();

  const noCookieYet = !cookie;
  const hasUnacceptedProvider =
    !!cookie && providerKeys.some(key => cookie[key] === null);
  if (noCookieYet || hasUnacceptedProvider) {
    const target: HTMLDivElement | null = document.querySelector(
      `[data-react=cookies-banner]`,
    );

    if (target) {
      if (!target.dataset.hideBanner) {
        doctrineAnalytics('Account CookieBannerShown');
        ReactDOM.render(
          <CommonAppProviders>
            <Banner onValid={acceptCookies} />
          </CommonAppProviders>,
          target,
        );
      }

      window.addEventListener('click', detectUserNavigationForOptIn);
    }
  }
  if (cookie && cookie.logrocket_cookie) {
    startLogRocket();
  }
}

window.addEventListener('load', displayCookieBannerWhenNeeded);
